export default __webpack_public_path__ + "static/media/2146.cefea77c.png";